import styled, { css } from "styled-components";
import tw from "twin.macro";

import { Item } from "./Item";

export const StyledNavListItemMore = styled(Item)`
  ${(props) =>
    props.role !== "light" &&
    css`
      padding: 0;
    `}
  cursor: pointer;

  &::after {
    content: "";
    ${tw`tw-absolute tw-block tw-m-auto tw-w-0 tw-bg-transparent`}
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 3px;
    transition: width 0.3s ease, background-color 0.3s ease;
    ${tw`tw-w-full tw-bg-primary`}
  }
`;

StyledNavListItemMore.displayName = "StyledNavListItemMore";
